/**
 * @type {import('../index.d').filterVariants}
 */
export function filterVariants(moduleContext, variants) {
  const hasPreorder = variants.some((variant) => variant.preorder);
  const { showOnPreOrderProduct } = moduleContext.settings.productSettings();

  if (hasPreorder && showOnPreOrderProduct.show) {
    return variants.filter(
      (variant) =>
        !variant.available ||
        (variant.available && variant.preorder && variant.inventory_quantity <= 0)
    );
  } else {
    return variants.filter((variant) => !variant.available);
  }
}

/**
 * @type {import('../index.d').checkIfVariantOutOfStock}
 */
export function checkIfVariantOutOfStock(product) {
  if (!product || !product.variants) return false;
  return product.variants.some((variant) => !variant.available);
}

/**
 * @type {import('../index.d').checkIfVariantPreOrder}
 */
export function checkIfVariantPreOrder(product) {
  if (!product.variants) return false;
  return product.variants.some(
    (variant) => variant.preorder && typeof variant.preorder === 'object'
  );
}
